import { useSyncExternalStore } from "react";
import { getIsLoggedIn } from "@/lib/Helpers/userHelpers";

// Same SharedHeader events accountDataCache.ts listens to (it registers first,
// at module import in providers.tsx, so localStorage is synced before we re-read).
const AUTH_EVENTS = [
  "lmn:checkAuth:successful",
  "lmn:login:successful",
  "lmn:logout:successful",
];

const subscribe = (onStoreChange: () => void) => {
  AUTH_EVENTS.forEach((e) => window.addEventListener(e, onStoreChange));
  // Cross-tab login/logout
  window.addEventListener("storage", onStoreChange);
  return () => {
    AUTH_EVENTS.forEach((e) => window.removeEventListener(e, onStoreChange));
    window.removeEventListener("storage", onStoreChange);
  };
};

const getServerSnapshot = () => false;

/**
 * Hydration-safe login state. Returns false on the server AND on the initial
 * hydration render (so server/client markup always match — React #418), then
 * the real localStorage value, re-rendering on auth events.
 *
 * Use this instead of calling getIsLoggedIn() in a component render body.
 */
export function useIsLoggedIn(): boolean {
  return useSyncExternalStore(subscribe, getIsLoggedIn, getServerSnapshot);
}
